import {Component, OnInit, Input, Output, EventEmitter, Injectable} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ErrorModalComponent} from '../error-modal/error-modal.component';
import {SuccessModalComponent} from '../success-modal/success-modal.component';
import {HttpClient} from '@angular/common/http';

@Injectable()
@Component({
  selector: 'pm-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css']
})
export class DeleteModalComponent implements OnInit {
  @Input() modalText: string; // Defines the title of the modal
  @Input() modcontent: string; // Defines the content of the modal
  @Input() disablebtn: boolean;
  @Input() deleteUserInfo: any;
  // Defines the enable/disable of the button
  @Input() removeBtn: boolean;
  @Output('cancelModal') cancelModal = new EventEmitter<any>(); // Emits the cancel event of the modal
  @Output() deleteModal = new EventEmitter<any>(); // Emits the delete event of the modal
  @Input() localDriverBtn: boolean;
  @Input() options: any;
  dialog: any;
  message: string;
  modalRef: any;

  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal, public router: Router, private _http: HttpClient) {
  }

  @Output() messageEvent = new EventEmitter<string>();
  @Output() refreshDeletePage = new EventEmitter<string>();

  ngOnInit() {
  }

  public delete() {
    this.deleteModal.emit({});
    this.activeModal.close();
  }

  public delete_user() {
    this._http.delete(window.location.origin + '/ftportal/uaa/api/users/' + this.deleteUserInfo.login)
      .subscribe(data => {
          this.deleteModal.emit({});
          this.activeModal.close();
          this.modalRef = this.modalService.open(SuccessModalComponent,
            {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'sucessModal'}).componentInstance;
          this.modalRef.updateUsers = true;
          this.modalRef.modcontent = 'Deletion Successful';
          this.modalRef.options = this.options;
        },
        error => {
          this.deleteModal.emit({});
          this.activeModal.close();
          this.modalRef = this.modalService.open(ErrorModalComponent,
            {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
          this.modalRef.modcontent = 'Deletion failed.Please try again';
        });
  }
}


